import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import A5Screening from "@/components/Screening/A5Screening";
import AccountSetup from "@/components/Common/Workflow/AccountSetup";
import AuthChallenge from "@/components/Authentication/AuthChallenge";
import EmailVerification from "@/components/Common/EmailVerification";
import HCPWorkflow from "@/components/Common/Workflow/HCPWorkflow/HCPWorkflow";
import MobileAddPayment from "@/components/Common/MobileAddPayment";
import privacyPolicy from "@/components/Common/PrivacyPolicy";
import Unsubscribe from "@/components/Common/Unsubscribe";
import Workflow from "@/components/Common/Workflow";

import AdvancedCarePolicyPage from "../PublicPages/AdvancedCarePolicyPage";
import Authentication from "../Authentication/Authentication";
import DashboardRouter from "../Dashboard/DashboardRouter";
import HipaaPolicyPage from "../PublicPages/HipaaPolicyPage";
import Home from "../Home/Home";
import PricingPage from "../PublicPages/PricingPage";
import PrivacyPolicyPage from "../PublicPages/PrivacyPolicyPage";
import RedirectSplashScreen from "../redirectSplashScreen";
import TermsAndConditionsPolicyPage from "../PublicPages/TermsAndConditionsPolicyPage";
import TreatmentPolicyPage from "../PublicPages/TreatmentPolicyPage";

export const STANDARD_UNAUTHENTICATED_ROUTES = (allowRedirect, props) => (
  <Switch>
    <Route component={Home} exact path="/" />
    <Route component={AccountSetup} path="/account-setup" />
    <Route component={Authentication} path="/auth" />
    <Route component={privacyPolicy} path="/privacy-policy" />
    <Route component={PricingPage} path="/session-pricing" />
    <Route component={A5Screening} path="/a5-screening" />
    <Route component={Unsubscribe} path="/unsubscribe" />
    <Route component={EmailVerification} path="/email-verification" />
    <Route component={Workflow} path="/app/workflow" />
    <Route component={MobileAddPayment} path="/app/mobile-add-payment" />

    <Route component={AdvancedCarePolicyPage} path="/advanced-care" />
    <Route component={TreatmentPolicyPage} path="/consent" />
    <Route component={HipaaPolicyPage} path="/hipaaprivacy" />
    <Route component={PrivacyPolicyPage} path="/privacy" />
    <Route component={TermsAndConditionsPolicyPage} path="/terms-and-conditions" />

    <Route
      component={(compProps) => (
        <RedirectSplashScreen {...compProps} redirectPath={props.auth.authRedirectPath} />
      )}
      path="/redirect"
    />

    <Route component={HCPWorkflow} path="/app/hcp-workflow" />

    {allowRedirect && <Redirect to="/auth" />}
  </Switch>
);

export const STANDARD_AUTHENTICATED_ROUTES = (_allowRedirect, props) => (
  <Switch>
    <Route
      path={props.auth.authRedirectPath}
      render={(compProps) => <DashboardRouter {...compProps} role={props.auth.role} />}
    />

    <Route
      component={(compProps) => (
        <RedirectSplashScreen {...compProps} redirectPath={props.auth.authRedirectPath} />
      )}
      path="/redirect"
    />

    <Route component={privacyPolicy} path="/privacy-policy" />
    <Route component={PricingPage} path="/session-pricing" />
    <Route component={Unsubscribe} path="/unsubscribe" />

    <Route component={AdvancedCarePolicyPage} path="/advanced-care" />
    <Route component={TreatmentPolicyPage} path="/consent" />
    <Route component={HipaaPolicyPage} path="/hipaaprivacy" />
    <Route component={PrivacyPolicyPage} path="/privacy" />
    <Route component={TermsAndConditionsPolicyPage} path="/terms-and-conditions" />

    <Redirect from="/auth" to={props.auth.authRedirectPath} />
    <Redirect to="/redirect" />
  </Switch>
);

export const STANDARD_CHALLENGE_ROUTES = (allowRedirect, props) => (
  <Switch>
    <Route component={AuthChallenge} path="/auth/challenge" />

    {allowRedirect && <Redirect to={props.auth.authRedirectPath} />}
  </Switch>
);

export const processRouteInitData = (allowRedirect, props) => {
  if (props.auth.role) {
    return STANDARD_AUTHENTICATED_ROUTES(allowRedirect, props);
  }

  if (props.auth.challengeName) {
    return STANDARD_CHALLENGE_ROUTES(allowRedirect, props);
  }

  return STANDARD_UNAUTHENTICATED_ROUTES(allowRedirect, props);
};
